// extracted by mini-css-extract-plugin
export default {"container":"LoadingSpinner_container__FvBnB","loading_spinner":"LoadingSpinner_loading_spinner__AvJQJ","spin":"LoadingSpinner_spin__DEfpF"};